import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
//import 'antd/dist/antd.css';
import EmailConfirmation from './components/Auth/EmailConfirmation';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Home from './components/Home/Home';
import InterestedPeople from './components/Home/Chat/InterestedPeople';
import ProfileContainer from './containers/ProfileContainer';
import Settings from './components/Home/Admin/Settings';
import LoadProfile from './components/Profile/LoadProfile';
import Conversations from './components/Home/Chat/Conversations';
import ProfileInfo from './components/Profile/info/ProfileInfo';
import ConversationRoom from './components/Home/Chat/ConversationRoom';
import EditProfile from './components/Home/Admin/EditProfile';
import Preferences from './components/Home/Admin/Preferences';
import Welcome from './components/Auth/Welcome';
import ChangePassword from './components/Auth/ChangePassword';
import ForgotPassword from './components/Auth/ForgotPassword';

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/account" component={Welcome} />
        <Route path="/account/register" component={Register} />
        <Route path="/account/login" component={Login} />
        <Route path="/account/confirmemail" component={EmailConfirmation} />
        <Route path="/account/reset/password" component={ChangePassword} />
        <Route path="/account/forgotpassword" component={ForgotPassword} />
        <Route path="/loadprofile" component={LoadProfile} />
        <Route path="/profile/create" component={ProfileContainer} />
        <Route path="/profile/edit" component={EditProfile} />
        <Route path="/profile/info" component={ProfileInfo} />
        <Route exact path="/conversations" component={Conversations} />
        <Route path="/conversations/messages/:user" component={ConversationRoom} />
        <Route path="/interested" component={InterestedPeople} />
        <Route exact path="/settings" component={Settings} />
        <Route path="/settings/preferences" component={Preferences} />
      </Switch>
    </Router>
  );
}

export default App;